import store from "@/js/store";

export async function isLeadsMovingFeatureEnabled() {
	return await store.dispatch("hasFeature", "LEADS_TRANSFER_INITIATING");
}

export function isTransferringInProgress(error) {
	// Related to:
	// DELETE "/leads/{id}"
	// DELETE "/leads/?someFilter=someValue"
	// DELETE "/leads/campaign/{campaignId}/?someFilter=someValue"
	return error && error.status === 409 && error.message === "LEADS_TRANSFER_IN_PROGRESS";
}
